import React, { useContext, useEffect, useState } from 'react';

import Image from 'next/image';
import { useSelector, useDispatch } from 'react-redux';

import {
    SET_USER_MENUS,
    SET_LANGUAGES,
    SET_CATEGORIES,
} from 'context/actions/system';
import { SET_ACCOUNT } from 'context/actions/auth';
// component
import Header from 'components/Header';
import Footer from 'components/Footer';
import MobileTabBar from 'components/MobileTabBar';
import DevelopeDialog from 'components/DevelopDialog';
import LoadingDialog from 'components/global/LoadingDialog';
import CustomSnackBar from 'components/CustomSnackBar';
import { SHOW_DEVELOP, SET_ALERT } from 'context/actions/system';
import { getPageList } from 'context/actions/pages';
import { getLangList } from 'context/actions/languages';
import { getCategoriesList } from 'context/actions/categories';
import { getBasketCount } from 'context/actions/basketProducts';
import Alert from '@mui/material/Alert';
import i18n from 'i18next';
import useWindowSize from 'utils/useWindowSize';

export default function HomeLayout({ children }) {
    const { sizes } = useWindowSize();

    const auth = useSelector((state) => state.auth);

    const system = useSelector((state) => state.system);

    const dispatch = useDispatch();
    const [isGetAllData, setGetAllData] = useState(false);
    const [isTimeoutShow, setTimeoutShow] = useState(true);

    useEffect(() => {
        getDatas();

        const myStopFunction = () => {
            setTimeoutShow(false);
            clearTimeout(myTimeout);
        };

        const myTimeout = setTimeout(myStopFunction, 600);
    }, []);

    const getDatas = async () => {
        const datas = await getPageList(true, '', dispatch);
        if (datas.status === 'success') {
            dispatch({
                type: SET_USER_MENUS,
                data: datas.data,
            });
        }
        const languages = await getLangList('&isActive=1');
        if (languages.status === 'success') {
            dispatch({
                type: SET_LANGUAGES,
                data: languages.data,
            });
        }
        const categoriesRes = await getCategoriesList(null, '&fromMenu=1');
        if (categoriesRes.status === 'success') {
            dispatch({
                type: SET_CATEGORIES,
                data: categoriesRes.data,
            });
        }

        const basketRes = await getBasketCount();
        if (basketRes.status === 'success' && auth?.account) {
            auth.account.accountInfo.basketCount = basketRes.data?.basketCount;
            dispatch({ type: SET_ACCOUNT, data: auth.account });
        }
        setGetAllData(true);
    };

    return (
        <>
            <div>
                <main>
                    {isGetAllData && !isTimeoutShow ? (
                        <>
                            <Header />
                            {/* pb-14: утсан дээр доод tab bar контентыг халхлахгүй */}
                            <div className="pb-14 md:pb-0">{children}</div>
                            <Footer />
                            <MobileTabBar />
                        </>
                    ) : (
                        <div className="flex flex-col flex-1 justify-center items-center h-screen">
                            <Image
                                width={50}
                                height={50} // Specify the height here
                                // height={48}
                                src={'/global/loading.gif'}
                                // src={i18n.language === 'mn' ? '/LogoFull.png' : '/LogoFull.png'}
                                // src={'/cover.png'}
                                alt=""
                                style={{ objectFit: 'cover' }}
                            />
                        </div>
                    )}
                    {system.showDevelop && (
                        <DevelopeDialog
                            open={system.showDevelop}
                            handleClose={() => {
                                dispatch({ type: SHOW_DEVELOP, data: false });
                            }}
                        />
                    )}

                    {system.showLoading && (
                        <LoadingDialog open={system.showLoading} />
                    )}
                    {system.alert.isShow && (
                        // <Alert severity={system.alert.type} variant="outlined" className="">
                        //     asf
                        // </Alert>

                        <CustomSnackBar
                            open={system.alert.isShow}
                            msg={system.alert.message}
                            handleClose={() => {
                                dispatch({
                                    type: SET_ALERT,
                                    data: {
                                        isShow: false,
                                        type: '',
                                        message: '',
                                    },
                                });
                            }}
                            type={system.alert.type}
                        />
                    )}
                </main>
            </div>
        </>
    );
}
